import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { SectionHeading } from './SectionHeading';
export function Testimonials() {
  return <section className="bg-ink-950 py-16 text-bone lg:py-24" data-id="element-215" data-mp="3fzdzvmnrkjqe">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-216" data-mp="3fxkv6cwpo9l1">
        <SectionHeading title="Ce qu’en disent mes clients" tone="dark" data-id="element-217" data-mp="3azjd9vb0ugb5" />

        <div className="mt-12 grid gap-px bg-ink-800 lg:grid-cols-3" data-id="element-218" data-mp="36yplgqugkhcz">
          {testimonials.map(item => <figure key={item.author} className="flex flex-col bg-ink-950 p-7 lg:p-8" data-id="element-219" data-mp="31zmsw5vo03lw">
              <QuoteIcon className="h-5 w-5 flex-none text-brass" aria-hidden="true" data-id="element-220" data-mp="2x09v4q399c4j" />
              <blockquote className="mt-5 text-base leading-relaxed text-bone-dark" data-id="element-221" data-mp="2s1ym2hksb5nd">
                {item.quote}
              </blockquote>
              <figcaption className="mt-auto pt-7 text-sm" data-id="element-222" data-mp="v8591v8ft91q">
                <span className="block font-display font-bold text-bone" data-id="element-223" data-mp="qalka1e45dvj">{item.author}</span>
                <span className="mt-0.5 block text-ink-500" data-id="element-224" data-mp="h5ya8j4cpl5q">{item.context}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}